var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dropdown",
    d: "M4.30714 8.29428C3.91738 8.68557 3.91862 9.31873 4.30991 9.70849C4.70119 10.0982 5.33436 10.097 5.72412 9.70572L4.30714 8.29428ZM9 5L9.70849 5.70572C10.0972 5.31552 10.0972 4.68448 9.70849 4.29428L9 5ZM5.72412 0.294279C5.33436 -0.0970098 4.70119 -0.0982486 4.30991 0.29151C3.91862 0.68127 3.91738 1.31443 4.30714 1.70572L5.72412 0.294279ZM1.00781 4C0.455527 4 0.0078123 4.44772 0.00781233 5C0.00781241 5.55229 0.455528 6 1.00781 6L1.00781 4ZM9.70849 4.29428L5.72412 0.294279L4.30714 1.70572L8.29151 5.70572L9.70849 4.29428ZM5.72412 9.70572L9.70849 5.70572L8.29151 4.29428L4.30714 8.29428L5.72412 9.70572ZM9 4L1.00781 4L1.00781 6L9 6L9 4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.30efa848ecbbeac04a805eaeb8fc4cf4.svg";
export { ForwardRef as ReactComponent };